module.exports = __webpack_public_path__ + "static/media/sunrise.3e64bb1e.JPG";